module.exports = __webpack_public_path__ + "static/hero-iic-white-e2207734b93fc859db3e06f8ecc4f9e5.png";